import SampleLibraryPage from './SampleLibraryPage';

export default SampleLibraryPage;
